import React from 'react';
import HttpHelper from '../../utils/HttpHelper';

export const handleDeleteClick = async (jobId: number) => {
    try {
      HttpHelper.delete(`jobs/${jobId}/delete`);
    } catch (error) {
      console.error('Failed to delete job', error);
    }
  };
